import script from "./ProductCardTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCardTitle.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCardTitle.vue?vue&type=style&index=0&id=11762494&lang=scss"

const __exports__ = script;

export default __exports__